export const Types = {
  SAVE_ALL_SPECIFICATIONS: 'SAVE_ALL_SPECIFICATIONS',
  SAVE_ALL_PROPERTIES: 'SAVE_ALL_PROPERTIES',
  SAVE_ALL_TAG: 'SAVE_ALL_TAG',
  SAVE_LIST_SPECIFICATIONS: 'SAVE_LIST_SPECIFICATIONS',
  SAVE_LIST_ALL_CATEGORY: 'SAVE_LIST_ALL_CATEGORY',
  SAVE_LIST_ALL_PRODUCE: 'SAVE_LIST_ALL_PRODUCE',
  SAVE_LIST_CATEGORY: 'SAVE_LIST_CATEGORY',
  SAVE_DETAIL_PRODUCE: 'SAVE_DETAIL_PRODUCE',
  SAVE_LIST_PROPERTY: 'SAVE_LIST_PROPERTY',
  SAVE_LIST_TAG_PRODUCT: 'SAVE_LIST_TAG_PRODUCT',
  SAVE_LIST_PRODUCT_VARIANT: 'SAVE_LIST_PRODUCT_VARIANT',
  SAVE_LIST_PRODUCT_VARIANT_PROP: 'SAVE_LIST_PRODUCT_VARIANT_PROP'
}
